import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { getProfileData } from '../../../Redux/action/MasterAction';
import { useDispatch, useSelector } from 'react-redux';
import { jwtDecode } from "jwt-decode";
import { db } from '../../firbase';
import { doc, updateDoc } from "firebase/firestore";
import axios from 'axios';

const host = process.env.REACT_APP_API_SERVER
const StudentSidebar = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authToken = localStorage.getItem('student-token');
    const handleLogout = async () => {
        try {

             axios.get(`${host}/api/web/change-online-status?status=0`, {
                headers: {
                    "x-auth-token": localStorage.getItem('student-token')
                }
            });

            localStorage.removeItem('student-token');

            navigate('/login', { state: { user: 'student' } });
        } catch (error) {
            console.error('Error while logging out:', error);
        }
    };
    // 


    return (
        <div className="sidebar-container">
            <aside id="sidebar-container">
                <nav className="navbar navbar-light">
                    <div className="container d-block">
                        {/* <div className="profile-img-sec">
                            <img
                                src={`${host}${ProfileDataListApiData?.data?.profile_img}`}
                                className="img-fluid w-auto"
                                onError={(e) => {
                                    e.target.src = '/assets/img/user/user.png'; // Fallback image
                                }}
                            />
                            <h5 className="mt-3 mb-0">{ProfileDataListApiData?.data?.name}</h5>

                        </div> */}
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link
                                    className={`${(pathname == '/student/dashboard') ? 'active nav-link' : 'nav-link'}`}
                                    aria-current="page"
                                    to="/student/dashboard"
                                >
                                    <i className="fa-solid fa-house-chimney" />
                                    &nbsp;Dashboard
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/browse-tutor' ? 'active nav-link' : 'nav-link'}`} to="/student/browse-tutor">
                                    <i class="fas fa-chalkboard-teacher"></i>
                                    &nbsp;Tutors
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/request-for-tutor' ? 'active nav-link' : 'nav-link'}`} to="/student/request-for-tutor">
                                    <i class="fa-solid fa-hand"></i>
                                    &nbsp;Request Tutor
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/my-sessions' ? 'active nav-link' : 'nav-link'}`} to="/student/my-sessions">
                                    <i class="fa-solid fa-video"></i>
                                    &nbsp;My sessions
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/my-online-lecture' ? 'active nav-link' : 'nav-link'}`} to="/student/my-online-lecture">
                                    <i class="fa-solid fa-earth-americas"></i>
                                    &nbsp;My Online lectures
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/notes-and-handouts' ? 'active nav-link' : 'nav-link'}`} to="/student/notes-and-handouts">
                                   <i class="fa-solid fa-file-contract"></i>
                                    &nbsp;Notes & Handouts
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/my-assignments' ? 'active nav-link' : 'nav-link'}`} to="/student/my-assignments">
                                    <i class="fa-solid fa-note-sticky"></i>
                                    &nbsp;My Assignments
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/bookings' ? 'active nav-link' : 'nav-link'}`} to="/student/bookings">
                                    <i className="fa fa-clock-o" />
                                    &nbsp;Booking
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/message' ? 'active nav-link' : 'nav-link'}`} to="/student/message">
                                    <i className="fa-solid fa-comments" />
                                    &nbsp;Message
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/my-queries' ? 'active nav-link' : 'nav-link'}`} to="/student/my-queries">
                                    <i className="fa-solid fa-clipboard-question" />
                                    &nbsp;My Queries
                                </Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className={`${pathname == '/student/notification' ? 'active nav-link' : 'nav-link'}`} to="/student/notification">
                                    <i className="fa-solid fa-bell" />
                                    &nbsp;Notification
                                </Link>
                            </li> */}
                            <li className="nav-item">
                                <Link className={`${pathname == '/student/contact-us' ? 'active nav-link' : 'nav-link'}`} to="/student/contact-us">
                                    <i className="fa-solid fa-users" />
                                    &nbsp;Contact us
                                </Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className={`${pathname == '/student/reviews' ? 'active nav-link' : 'nav-link'}`} to="/student/reviews">
                                    <i className="fa-solid fa-star" />
                                    &nbsp;Reviews
                                </Link>
                            </li> */}
                            {/* <li className="nav-item">
                                <Link className={`${(pathname == '/student/profile' || pathname == '/student/profile-update') ? 'active nav-link' : 'nav-link'}`} to="/student/profile">
                                    <i className="fa fa-user-circle-o" />
                                    &nbsp;Profile
                                </Link>
                            </li> */}
                            <li className="nav-item">
                                <Link
                                    className="nav-link btn text-start"

                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                >
                                    <i className="fa-solid fa-right-from-bracket" />
                                    &nbsp;Logout
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </aside>
            <div
                className="modal fade logout-modal"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div
                            className="modal-body my-4"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                            <h4>Log out</h4>
                            <p>Are you sure you want to log out?</p>
                            <div className="modal-footer">
                                <Link onClick={handleLogout}>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                                        Logout
                                    </button>
                                </Link>
                                <Link to="">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StudentSidebar